<template>
  <div class="user-item">
    <div class="action-message">
      {{ getActionMessage() }}
    </div>
    <div class="info-row">
      <span class="info-label">{{ $t("alarm.timeline.full_name") }}:</span>
      <span class="info-value">{{ item.data.user.full_name }}</span>
    </div>
    <div class="info-row">
      <span class="info-label">{{ $t("alarm.timeline.soeid") }}:</span>
      <span class="info-value">{{ item.data.user.user }}</span>
    </div>
  </div>
</template>

<script>
import {useUtils as useI18nUtils} from "@core/libs/i18n";

export default {
  name: "AlarmWorkflowItem",
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const {t} = useI18nUtils();

    const getActionMessage = () => {
      switch (props.item.data.action.action) {
        case "TAKEN":
          return t("alarm.timeline.TAKEN");
        case "RELEASED":
          return t("alarm.timeline.RELEASED");
        case "SENT_TO_REVIEW":
          return t("alarm.timeline.SENT_TO_REVIEW");
        case "CHANGES_REQUESTED":
          return t("alarm.timeline.CHANGES_REQUESTED");
        case "SUPERVISOR_TAKEN_FROM_POOL":
          return t("alarm.timeline.SUPERVISOR_TAKEN_FROM_POOL");
        case "OPERATOR_RESUMED_WORK":
          return t("alarm.timeline.OPERATOR_RESUMED_WORK");
        case "COMPLETED":
          return t("alarm.timeline.COMPLETED");
        case "MANUAL_ALARM_DISPATCHED":
          return 'Alarma manual activada';
        case "MANUAL_ALARM_RESTORED":
          return 'Alarma manual restaurada';
        case "SENT_TO_MAINTENANCE":
          return 'Alarma en mantenimiento';
        case "RESOLVED_MAINTENANCE":
          return 'Alarma fuera de mantenimiento';
        default:
          return "unknown";
      }
    };

    return {
      getActionMessage,
    };
  },
};
</script>

<style scoped lang="scss">
.user-item {
  padding: 0.75rem;
  background-color: #f8f9fa;
  border-radius: 6px;
  margin-top: 0.5rem;
}

.dark-layout .user-item {
  background-color: rgba(255, 255, 255, 0.05);
}

.action-message {
  font-weight: 600;
  font-size: 0.95rem;
  color: #495057;
  margin-bottom: 0.75rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #dee2e6;
}

.dark-layout .action-message {
  color: #e9ecef;
  border-bottom-color: rgba(255, 255, 255, 0.1);
}

.info-row {
  display: flex;
  flex-direction: row;
  margin-bottom: 0.5rem;
  gap: 0.5rem;
}

.info-row:last-child {
  margin-bottom: 0;
}

.info-label {
  font-weight: 600;
  color: #6c757d;
  min-width: 80px;
}

.dark-layout .info-label {
  color: #adb5bd;
}

.info-value {
  color: #495057;
  flex: 1;
}

.dark-layout .info-value {
  color: #e9ecef;
}
</style>
